import { ADD_SENIOR_FAIL, ADD_SENIOR_REQUEST, ADD_SENIOR_SUCCESS, SeniorAction, SeniorState } from "../types";

const initialState: SeniorState = {
    senior: {
        username: "",
        firstName: "",
        lastName: "",
        password: "",
    },
    loading: false,
    error: null,
};

const senior = (state = initialState, action: SeniorAction): SeniorState => {
    switch (action.type) {
        case ADD_SENIOR_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case ADD_SENIOR_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
            };
        case ADD_SENIOR_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};

export default senior;
